import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Avoid loading twice
    if ((window as any).fbq) return;
    const f = window as any;
    const b = document as any;
    let n: any;
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const s = b.createElement('script');
    s.async = true;
    s.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(s);
    (window as any).fbq('init', '931401796468747');
    (window as any).fbq('track', 'PageView');
    // Add noscript pixel fallback
    const noscript = b.createElement('noscript');
    const img = b.createElement('img');
    img.height = '1';
    img.width = '1';
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=931401796468747&ev=PageView&noscript=1';
    noscript.appendChild(img);
    b.body.appendChild(noscript);
  }, []);
  return null;
}